import Login from '@/pages/auth/login/index.vue';
import Main from '@/pages/main/index.vue';
import MarkerSetList from '@/pages/main/marker-set-list/index.vue';
import MarkerList from '@/pages/main/marker-list/index.vue';

const routes = [
  { path: '/login', component: Login, alias: '/' },
  {
    path: '/main',
    component: Main,
    children: [{
      path: 'marker-set',
      component: MarkerSetList,
      alias: '',
    }, {
      name: 'markerList',
      path: 'marker-set/:id',
      component: MarkerList,
      props: true,
    }],
  },
];
export default routes;
